var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showWarning)?_c('div',{staticClass:"banner",attrs:{"id":"azure-warn"}},[_c('p',[_vm._v("\n    "+_vm._s(_vm.t('authConfig.azuread.updateEndpoint.banner.message'))+"\n    "),_c('n-link',{attrs:{"to":_vm.authConfigRoute}},[_vm._v("\n      "+_vm._s(_vm.t('authConfig.azuread.updateEndpoint.banner.linkText'))+"\n    ")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }